module.exports = __webpack_public_path__ + "static/media/phone.bdd719c6.png";